import React from "react";
import { Component } from "react";
import { Button, Col, Row, Grid } from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import DefaultActionManager from "../../../action_managers/default_action_manager";
import { USER_ATTRIBUTE } from "../../../actions/user";
import { HAS_SEEN_WELCOME_MODAL } from "../../../constants/user_attributes";
import { isSuccessStatus } from "../../../lib/http";
import "./sponsor_sign_up.scss";
import { addRole } from "../../../action_managers/account";
import UserRoles from "../../../constants/roles";
import { updateCurrentRole } from "../../../actions/account";
import { saveUserRole } from "../../../lib/user_store";
import PageWrapper from "../../lib/page-wrapper";
import ExternalLink from "../../lib/external_link";

class SponsorSignUpPage extends Component {
  signUp = () => {
    this.props.addRole(this.props.user, UserRoles.Creator).then(response => {
      if (isSuccessStatus(response.status)) {
        this.props.updateRole(UserRoles.Creator);
        saveUserRole(UserRoles.Creator);
        this.props.markWelcomeModalNotSeen().then(() => {
          this.props.history.push("/shows");
        });
      }
    });
  };

  render() {
    return (
      <PageWrapper noDivider>
        <Grid fluid>
          <Row>
            <Col className="align-middle sponsor-sign-up__body" xs={12} md={6}>
              <h4>Thinking of starting a podcast? It's easy to get started on RedCircle.</h4>
              <p>
                Learn about what we have to offer{" "}
                <ExternalLink href="https://redcircle.com/our-promise">here</ExternalLink>.
              </p>
              <Button onClick={this.signUp} bsStyle="primary">
                Start a Podcast
              </Button>
            </Col>
          </Row>
        </Grid>
      </PageWrapper>
    );
  }
}

export default withRouter(
  connect(
    state => {
      return { user: state.user.user };
    },
    dispatch => {
      return {
        // once the user signs up we want to show them the welcome modal again to introduce them to the
        // podcasting side of things
        markWelcomeModalNotSeen: () => {
          return dispatch(
            new DefaultActionManager({
              auth: true,
              route: `users/me/set-attribute`,
              actionName: USER_ATTRIBUTE,
              method: "POST",
              body: {
                key: HAS_SEEN_WELCOME_MODAL,
                value: "false",
              },
            }).run()
          );
        },
        addRole: (user, role) => dispatch(addRole(user, role)),
        updateRole: role => dispatch(updateCurrentRole(role)),
      };
    }
  )(SponsorSignUpPage)
);
